import EdSection from './ed-section/ed-section.vue';
import EdCourseContentSidebar from './ed-course-content-sidebar/ed-course-content-sidebar.vue';

export const CoursesComponents = {
  EdSection,
  EdCourseContentSidebar
}